import { Button, FileField, FileInput, RadioButtonGroupInput, required, useNotify, useRefresh } from "react-admin";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Box, Grid, Tooltip } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import { AdvancedSpecialistStatuses } from "utils/constants";

const UploadFinalExamProtocolDialog = ({ id, fullyCoversStudyDuration, statusId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const blockedReason = !fullyCoversStudyDuration
    ? "Протокол от финален изпит може да се качи само след като периодите покрият цялата продължителност на обучението."
    : statusId === AdvancedSpecialistStatuses.Graduated
      ? "Специализантът вече е завършил и не може да се качи нов протокол."
      : null;

  const handleSubmit = async data => {
    const payload = {
      isPassed: data.isPassed,
      protocolFile: data.protocolFile,
    };
    await dataProvider.customRequest(
      specialistRequests.addAdvancedSpecializationSpecialistFinalExamProtocol(id),
      payload,
      "POST",
      undefined, // params
      true, // isMultipart — payload съдържа protocolFile
    );
    notify("Успешно качихте протокола от финален изпит", { type: "success" });
    refresh();
  };

  if (blockedReason) {
    return (
      <Tooltip title={blockedReason}>
        <span>
          <Button
            label="Качи протокол от финален изпит"
            startIcon={<UploadFileIcon />}
            variant="contained"
            sx={{ mb: 2 }}
            disabled
          />
        </span>
      </Tooltip>
    );
  }

  return (
    <FormModal
      titleContent={"Качване на протокол от финален изпит"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label="Качи протокол от финален изпит"
          startIcon={<UploadFileIcon />}
          sx={{ mb: 2 }}
          variant="contained"
        />
      }
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <RadioButtonGroupInput
            source="isPassed"
            label="Резултат от финален изпит"
            choices={[
              { id: true, name: "Издържан" },
              { id: false, name: "Неиздържан" },
            ]}
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <FileInput
            placeholder={
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                <UploadFileIcon />
                {"Добавете файл в pdf, png или jpg формат"}
              </Box>
            }
            source="protocolFile"
            label="Протокол от финален изпит"
            accept={{
              "application/pdf": [".pdf"],
              "image/png": [".png"],
              "image/jpeg": [".jpg", ".jpeg"],
            }}
            validate={required()}
          >
            <FileField
              source="src"
              title="title"
            />
          </FileInput>
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default UploadFinalExamProtocolDialog;
